import {
  Grid,
} from "@material-ui/core";
import { Sidebar } from "../Sidebar";
import InvoiceTable from "./InvoiceTable";

export const InvoicePage = () => {
  return (
    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <InvoiceTable />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
